export default "__VITE_ASSET__222172c0__"